const styles = `:host {
  box-sizing: border-box;
  display: inline-flex;
  gap: var(--goto-spacing-02);
}
:host .positioning-region {
  display: flex;
  gap: var(--goto-spacing-02);
}

:host([orientation=vertical]) {
  flex-direction: column;
}
:host([orientation=vertical]) .positioning-region {
  flex-direction: column;
}

::slotted([slot=label]) {
  color: var(--goto-type-color-default);
  font: var(--goto-caption-medium-strong);
}`; export default styles;